<template>
    <div class="container bankBossAudit" v-if="isVisible" style="z-index:1">
        <div class="bankAuditDialog">
            <el-row>
                <el-col :span="24">
                    <div class="bankAuditHeader">
                        <div class="bankAuditHeaderName">银行总负责人审核</div>
                        <div class="bankAuditHeaderClose" title="关闭" @click="onChangeClose">×</div>
                    </div>
                </el-col>
            </el-row>
            <el-scrollbar style="height:100%:padding:0px 20px" :noresize="true">
                <el-row>
                    <el-col :span="24">
                        <div class="bankAuditTitle">
                            <div class="bankAuditSplit"></div>
                            审核信息
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                        <el-col :span="3" v-if="flowInfo.PersonFlag===1">
                            <div class="bankAuditLB">姓名：</div>
                        </el-col>
                        <el-col :span="5" v-if="flowInfo.PersonFlag===1">
                            <div class="bankAuditContent"> 
                                <el-input
                                    disabled
                                    v-model="flowInfo.Name"
                                    size="small">
                                </el-input>
                            </div>
                        </el-col>
                        <el-col :span="3" v-if="flowInfo.PersonFlag===2">
                            <div class="bankAuditLB">公司名称：</div>
                        </el-col>
                        <el-col :span="5" v-if="flowInfo.PersonFlag===2">
                            <div class="bankAuditContent"> 
                                <el-input
                                    disabled
                                    v-model="flowInfo.Company"
                                    size="small">
                                </el-input>
                            </div>
                        </el-col>
                        <el-col :span="3" v-if="flowInfo.PersonFlag===2">
                            <div class="bankAuditLB">法定代表人：</div>
                        </el-col>
                        <el-col :span="5" v-if="flowInfo.PersonFlag===2">
                            <div class="bankAuditContent"> 
                                <el-input
                                    disabled
                                    v-model="flowInfo.Name"
                                    size="small">
                                </el-input>
                            </div>
                        </el-col>
                        <el-col :span="3" v-if="flowInfo.PersonFlag===1">
                            <div class="bankAuditLB">身份证号：</div>
                        </el-col>
                        <el-col :span="5" v-if="flowInfo.PersonFlag===1">
                            <div class="bankAuditContent"> 
                                <el-input
                                    disabled
                                    v-model="flowInfo.IdCard"
                                    size="small"
                                    placeholder="请输入身份证号">
                                </el-input>
                            </div>
                        </el-col>
                        <el-col :span="3" v-if="flowInfo.PersonFlag===2">
                            <div class="bankAuditLB">营业执照：</div>
                        </el-col>
                        <el-col :span="5" v-if="flowInfo.PersonFlag===2">
                            <div class="bankAuditContent"> 
                                <el-input
                                    disabled
                                    v-model="flowInfo.Code"
                                    size="small"
                                    placeholder="请输入营业执照">
                                </el-input>
                            </div>
                        </el-col>
                </el-row>
                <el-row>
                    <el-col :span="3">
                        <div class="bankAuditLB">联系方式：</div>
                    </el-col>
                    <el-col :span="5">
                        <div class="bankAuditContent"> 
                            <el-input
                                disabled
                                v-model="flowInfo.Phone"
                                size="small"
                                placeholder="请输入联系方式">
                            </el-input>
                        </div>
                    </el-col>
                    <el-col :span="3">
                        <div class="bankAuditLB">申请金额(万元)：</div>
                    </el-col>
                    <el-col :span="5">
                        <div class="bankAuditContent"> 
                            <el-input
                                disabled
                                v-model="flowInfo.Money"
                                size="small"
                                placeholder="请输入申请金额">
                            </el-input>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="bankAuditTitle">
                            <div class="bankAuditSplit"></div>
                            审核材料
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="bankAuditPicList" v-if="uploadPicFile.length>0">
                            <el-upload
                                accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PBG,"
                                class="avatar-uploader"
                                ref="upload"
                                list-type="picture-card"
                                :limit=4
                                :file-list="picList"
                                :before-upload="beforeAvatarPicUpload"
                                :http-request="uploadPicFile">
                                <template #default>
                                    <i class="el-icon-picture avatar-uploader-icon">图片</i>
                                </template>
                                <template #file="{ file }">
                                <div>
                                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                                    <span class="el-upload-list__item-actions">
                                        <span
                                            class="el-upload-list__item-preview"
                                            @click="handlePictureCardPreview(file)">
                                            <i class="el-icon-zoom-in"></i>
                                        </span>
                                        <span v-if="!disabled" class="el-upload-list__item-delete" @click="handlePicDownload(file)">
                                            <i class="el-icon-download"></i>
                                        </span>
                                    </span>
                                </div>
                                </template>
                            </el-upload>
                            <el-dialog custom-class="bankAuditImagePreview" v-model="dialogVisible">
                                <img width="100%" :src="dialogImageUrl" alt="" />
                            </el-dialog>
                        </div>
                        <div class="bankAuditFileList" v-if="fileList.length>0">
                            <div v-for="(item,index) in fileList" :key="index">
                                <div class="bankAuditFileLink" :title="item.name" @click="handlePicDownload(item)">文件：{{item.name}}</div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="bankAuditTitle">
                            <div class="bankAuditSplit"></div>
                        信用信息
                        </div>
                    </el-col>
                </el-row>
                <!-- <el-row>
                    <el-col :span="24">
                        <div class="bankAuditQueryTime">查询时间：{{queryTime}}</div>
                    </el-col>
                </el-row> -->
                <el-row v-if="flowInfo.PersonFlag===2">
                    <el-col :span="24">
                        <div class="bankAuditSecondLB">
                            <div class="bankAuditSecondSplit"></div>
                            营业执照信息
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="flowInfo.PersonFlag===2">
                    <el-col :span="24">
                        <div class="bankAuditInfoTitle">
                            <img width="50" height="50" :src="detailResult.ImageUrl"/>
                            <div class="bankAuditInfoName">{{detailResult.Name}}</div>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="flowInfo.PersonFlag===2">
                    <el-col :span="24">
                        <div class="bankAuditInfoTable">
                            <table border="1" bordercolor="#4e717d">
                                <tr>
                                    <td class="title">登记机关</td>
                                    <td>{{detailResult.BelongOrg}}</td>
                                    <td class="title">法定代表人名</td>
                                    <td style="color:bule ">{{detailResult.OperName}}</td>
                                </tr>
                                <tr>
                                    <td class="title">成立日期</td>
                                    <td>{{detailResult.StartDate}}</td>
                                    <td class="title">企业状态</td>
                                    <td>{{detailResult.Status}}</td>
                                </tr>
                                <tr>
                                    <td class="title">注册资本</td>
                                    <td>{{detailResult.RegistCapi}}</td>
                                    <td class="title">实缴资本</td>
                                    <td>{{detailResult.RecCap}}</td>
                                </tr>
                                <tr>
                                    <td class="title">企业类型</td>
                                    <td>{{detailResult.EconKind}}</td>
                                    <td class="title">注册号</td>
                                    <td>{{detailResult.No}}</td>
                                </tr>
                                <tr>
                                    <td class="title">地址</td>
                                    <td colspan="3">{{detailResult.Address}}</td>
                                </tr>
                                <tr>
                                    <td class="title">经营范围</td>
                                    <td colspan="3">{{detailResult.Scope}}</td>
                                </tr>
                            </table>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="bankAuditSecondLB">
                            <div class="bankAuditSecondSplit"></div>
                            诉讼信息
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="bankAuditInfoTable">
                            <table class="bg-table" border="1" bordercolor="#4e717d">
                                <tr>
                                    <td class="title">开庭公开数</td>
                                    <td class="content">{{caseResult.CourtAnnoCount}}</td>
                                    <td class="title">法院公告数量</td>
                                    <td class="content">{{caseResult.CourtNotiCount}}</td>
                                    <td class="title">裁判文书数量</td>
                                    <td class="content">{{caseResult.JudgeCount}}</td>
                                    <td class="title">股权冻结数量</td>
                                    <td class="content">{{caseResult.JudicialAssCount}}</td>
                                </tr>
                                <tr>
                                    <td class="title">失信被执行人数量</td>
                                    <td>{{caseResult.SXCount}}</td>
                                    <td class="title">被执行人数量</td>
                                    <td>{{caseResult.ZXCount}}</td>
                                    <td class="title">立案信息数量</td>
                                    <td>{{caseResult.CaseFilingCount}}</td>
                                    <td class="title">限制高消费数量</td>
                                    <td>{{caseResult.STCount}}</td>
                                </tr>
                                <tr>
                                    <td class="title">终本案件数量</td>
                                    <td>{{caseResult.ENCCount}}</td>
                                    <td class="title">送达公告数量</td>
                                    <td >{{caseResult.DLNCount}}</td>
                                    <td class="title">个人被执行信息</td>
                                    <td  @click="queryClick(1)" style="cursor: pointer">
                                            <span v-if="llTableData.length>0" style="color: red">
                                            {{llTableData.length}}
                                        </span>
                                        <span v-else>0</span>
                                    </td>
                                    <td class="title">公司被执行信息</td>
                                    <td  @click="queryClick(2)" style="cursor: pointer;">
                                        <span v-if="cllTableData.length>0" style="color: red">
                                            {{cllTableData.length}}
                                        </span>
                                        <span v-else>0</span>
                                    </td>
                                </tr>
                            </table> 
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="llShow">
                    <el-col :span="24">
                        <div class="bankAuditSecondLB">
                            <div class="bankAuditSecondSplit"></div>
                            个人老赖
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="llShow">
                    <el-col :span="24">
                        <div class="bankAuditInfoTable">
                            <table class="bg-table" border="1" bordercolor="#4e717d">
                                <tr v-if="!llTableData||llTableData.length===0">
                                    <td colspan="4">没有查询到个人老赖信息</td>
                                </tr>
                                <template v-else>
                                    <tr>
                                        <td class="title">名称</td>
                                        <td style="width:36%">{{llTableData[0].Name}}</td>
                                        <td class="title">证件号</td>
                                        <td>{{llTableData[0].CerNo}}</td>
                                    </tr>
                                    <tr>
                                        <td class="title">失信数量</td>
                                        <td style="color:red;cursor: pointer">{{llTableData[0].Count}}</td>
                                    </tr>
                                </template>
                            </table> 
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="cllShow">
                    <el-col :span="24">
                        <div class="bankAuditSecondLB">
                            <div class="bankAuditSecondSplit"></div>
                            公司老赖信息
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="cllShow">
                    <el-col :span="24">
                        <div class="bankAuditInfoTable">
                            <table class="bg-table" border="1" bordercolor="#4e717d">
                                <tr v-if="!cllTableData||cllTableData.length===0">
                                    <td colspan="4">没有查询到公司老赖信息</td>
                                </tr>
                                <template v-else>
                                    <tr>
                                        <td class="title">名称</td>
                                        <td style="width:36%">{{cllTableData[0].Name}}</td>
                                        <td class="title">证件号</td>
                                        <td>{{cllTableData[0].CerNo}}</td>
                                    </tr>
                                    <tr>
                                        <td class="title">失信数量</td>
                                        <td colspan="3" style="color:red;cursor: pointer">{{cllTableData[0].Count}}</td>
                                    </tr>
                                </template>
                            </table> 
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="llShow">
                    <el-col :span="24">
                        <div class="bankAuditSecondLB">
                            <div class="bankAuditSecondSplit"></div>
                            失信列表
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="llShow">
                    <el-col :span="24">
                        <div class="bankAuditInfoTable">
                            <table class="bg-table" border="1" bordercolor="#4e717d">
                                <tr v-if="!llListResult||llListResult.length===0">
                                    <td colspan="4">没有查询到失信信息</td>
                                </tr>
                                <template v-else>
                                    <tr>
                                        <td class="title" style="width:25%">案号</td>
                                        <td class="title" style="width:25%">执行法院</td>
                                        <td class="title" style="width:25%">履行情况</td>
                                        <td class="title" style="width:25%">发布日期</td>
                                    </tr>
                                    <tr v-for="(abc,i) in llListResult" :key="i">
                                        <td>{{abc.CaseNo}}</td>
                                        <td>{{abc.ExecuteGov}}</td>
                                        <td>{{abc.ExecuteStatus}}</td>
                                        <td>{{abc.PublicDate}}</td>
                                    </tr>
                                </template>
                            </table> 
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="cllShow">
                    <el-col :span="24">
                        <div class="bankAuditSecondLB">
                            <div class="bankAuditSecondSplit"></div>
                            失信列表
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="cllShow">
                    <el-col :span="24">
                        <div class="bankAuditInfoTable">
                            <table class="bg-table" border="1" bordercolor="#4e717d">
                                <tr v-if="!cllListResult||cllListResult.length===0">
                                    <td colspan="4">没有查询到失信信息</td>
                                </tr>
                                <template v-else>
                                    <tr>
                                        <td class="title" style="width:25%">案号</td>
                                        <td class="title" style="width:25%">执行法院</td>
                                        <td class="title" style="width:25%">履行情况</td>
                                        <td class="title" style="width:25%">发布日期</td>
                                    </tr>
                                    <tr v-for="(abc,i) in cllListResult" :key="i">
                                            <td>{{abc.CaseNo}}</td>
                                            <td>{{abc.ExecuteGov}}</td>
                                            <td>{{abc.ExecuteStatus}}</td>
                                            <td>{{abc.PublicDate}}</td>
                                    </tr>
                                </template>
                            </table> 
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="bankAuditSecondLB">
                            <div class="bankAuditSecondSplit"></div>
                            政务信息
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="bankAuditInfoTable">
                            <table class="bg-table" border="1" bordercolor="#4e717d">
                                <tr>
                                    <td class="title">婚姻信息</td>
                                    <td></td>
                                    <td class="title">户籍信息</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="title">社保信息</td>
                                    <td></td>
                                    <td class="title">农村低保</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="title">城市低保</td>
                                    <td></td>
                                    <td class="title">农村五保</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="title">公积金信息</td>
                                    <td></td>
                                    <td class="title">公积金个人明细账</td>
                                    <td></td>
                                </tr>
                            </table> 
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="bankAuditOperate">
                            <el-button size="small" type="danger" @click="onReturnFlow">拒绝</el-button>
                            <el-button size="small" type="success" @click="onPassFlow">通过</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-scrollbar>
        </div>
    </div>
</template>

<script>
import indexJs from "./index.js";
  export default indexJs;
</script>

<style>
    @import url(./assets/style/style.less);
</style>
